import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing, palette }) => ({
  button: {
    backgroundColor: palette.primary.light,
    borderRadius: spacing(3),
    color: palette.primary.main,
    display: "flex",
    justifyContent: "flex-end",
    margin: "-6px 0",
    padding: "8px 16px",
  },
  icon: {
    marginRight: 4,
    strokeWidth: 1.5,
  },
}));
